import React, { useState } from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import NavBarBackground from "./NavBarBackground"
import NavBarContainer from "./NavBarContainer"
import Logo from "./Logo"
import Menu from "./Menu"
import MobileMenu from "./MobileMenu"
import MindMeLogo from "../../../images/branding/mindme-logo-color.svg"
import MindMeLogoWhite from "../../../images/branding/mindme-logo-white.svg"
import DarkModeToggle from "../DarkModeToggle"

import useLockBodyScroll from "../../../utils/hooks/useLockBodyScroll"

const Background = ({ megaMenuOpen, setMegaMenuOpen }) => {
  useLockBodyScroll()

  return (
    <Bg
      className={megaMenuOpen.open ? "reveal" : ""}
      onClick={() => setMegaMenuOpen({ open: false, menu: null })}
    />
  )
}

const Navigation = ({ currentPath, stickySubNav, setStickySubNav }) => {
  const [megaMenuOpen, setMegaMenuOpen] = useState({ open: false, menu: null })
  return (
    <>
      <NavBarBackground className={stickySubNav ? "stickyNav" : ""}>
        <NavBarContainer>
          <Link to="/">
            <Logo src={stickySubNav ? MindMeLogoWhite : MindMeLogo} />
          </Link>
          <Menu
            stickySubNav={stickySubNav}
            megaMenuOpen={megaMenuOpen}
            setMegaMenuOpen={setMegaMenuOpen}
          />
          <MobileMenu />
          {/* <DarkModeToggle /> */}
        </NavBarContainer>
      </NavBarBackground>
      {megaMenuOpen.open && (
        <Background
          setMegaMenuOpen={setMegaMenuOpen}
          megaMenuOpen={megaMenuOpen}
        />
      )}
    </>
  )
}
export default Navigation

const Bg = styled.div`
  ${({ theme }) => theme.se`
  display: none;
`}

  ${({ theme }) => theme.desktop`
   display: none;
  
  &.reveal {
    display: block;
    transition: all 300ms linear;
    position: absolute;
    width: 100vw;
    height: 100vh;
    background-color: rgba(14, 41, 56, 0.8); 
    backdrop-filter: saturate(180%) blur(20px);
    top: 0;
    left: 0;
    z-index: 900;
  }
`}
`
